import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavUserComponent } from './nav-user/nav-user.component';
import { AlertaModule } from '../alerta/alerta.module';
import { AuthModule } from '../auth/auth.module';
import { RouterModule } from '@angular/router';
import { NgxSimpleBreadcrumbModule } from 'ngx-simple-breadcrumb';
import { UtilModule } from '../util/util.module';
import { TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    NavUserComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    AlertaModule,
    AuthModule,
    RouterModule,
    NgxSimpleBreadcrumbModule,
    UtilModule,
    TranslatePipe,
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    NavUserComponent,
    SidebarComponent,
  ],
})
export class CoreModule {}
